import { useAppSelector } from '@/hooks/storeHooks/storehooks'
import { useAuth0 } from '@auth0/auth0-react'
import Loader from '@/components/atom/loader/loader'
import { Navigate, useLocation } from 'react-router-dom'
import React from 'react'

export const isPathAllowed = (currentPath: string, allowedPaths: string[]) => {
  const normalize = (path: string) => path.split('?')[0].replace(/\/+$/, '')
  const normalizedCurrent = normalize(currentPath)

  // Always allow Wiki / AI Chatbot page on portaldev / localhost environments
  const isPortalDev =
    window.location.hostname.includes('portaldev') ||
    window.location.hostname === 'localhost'

  if (
    isPortalDev &&
    (normalizedCurrent === '/wiki' ||
      normalizedCurrent.startsWith('/wiki/') ||
      normalizedCurrent === '/app/wiki' ||
      normalizedCurrent.startsWith('/app/wiki/'))
  ) {
    return true
  }

  return allowedPaths.some(path =>
    normalizedCurrent.startsWith(normalize(path)),
  )
}

type ProtectedRouteProps = {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, error, logout } = useAuth0()
  const location = useLocation()
  const loader = useAppSelector(state => state.menu.appLoader)
  const allowedPaths = useAppSelector(state => state.menu.paths)

  const currentPath = location.pathname
  const isAllowed = isPathAllowed(currentPath, allowedPaths)

  console.log(
    error,
    'error',
    allowedPaths.length,
    'allowedPaths.length',
    isAuthenticated,
    'isAuthenticated',
    isAllowed,
    'isAllowed',
  )

  if (error) {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  if (loader || isLoading || allowedPaths.length === 0) {
    return (
      <div data-testid='loading' className='flex h-screen w-full'>
        <Loader />
      </div>
    )
  }

  if (!isAuthenticated && !isLoading) {
    return <Navigate to='/expired' state={{ from: location }} replace />
  }

  if (!isAllowed) {
    return <Navigate to='/unauthorized' replace />
  }

  return <>{children}</>
}
